// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.containerHomePage {
  display: flex;
  position: relative;
}

.containerRequest {
  display: flex;
  width: calc(100% - 55px);
  padding: 30px 0px 0px 35px;
  flex-direction: column;
  margin-bottom: 30px;
}

.nullDescription {
  color: #979ea4;
}

.centerText {
  width: 100%;
  text-align: left;
  color: #979ea4;
}

.centerTextBlack {
  color: #000;
}

.titleRequest {
  font-size: 18px;
}

.containerBalls {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.partNumberColluns {
  display: flex;
  padding-left: 20px;
  font-size: 14px;
}

.genericGrid {
  width: 100%;
  display: flex;
  padding: 0px 50px 20px 35px;
}

.containerGraphs {
  width: 100%;
  padding: 0px 50px 100px 35px;
}

.MuiDataGrid-root .MuiDataGrid-footerContainer {
  border: none !important;
  height: 0px !important;
  background-color: #f9f9f9 !important;
}

.MuiDataGrid-root {
  border: none !important;
  height: 92% !important;
}

.MuiDataGrid-root .MuiDataGrid-filler {
  background-color: #f9f9f9 !important;
  border: none !important;
  height: 0px !important;
}

.buttonImg img {
  width: 22px;
}

.buttonActions {
  margin-top: -15px;
}

.titleAprover {
  font-size: 18px;
  font-weight: 700;
}

div.titleAproverText {
  font-size: 18px;
  font-weight: 400;
  font-family: "Bosch Sans", sans-serif !important;
}

.css-183rme2 {
  display: none !important;
}

.ModalViewDescriptions {
  height: 190px;
}

.containerCards {
  display: flex;
  justify-content: space-between;
}

.title_dash {
  position: absolute;
  border-bottom: 2px solid #ccc;
  width: 100%;
  top: 0;
}

.title_dash h2 {
  color: #000;
  font-weight: 700;
  font-size: 20px;
  margin: 10px;
}

.no_results {
  font-weight: 400;
  font-size: 20px;
  color: #979ea4;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.wrap_text {
  width: 180px;
}

.btn-delete{
  cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/componentes/fluxo-engenheiro/AprovadorEng/aprovadorEng.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,MAAM;AACR;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;AACjB","sourcesContent":[".containerHomePage {\n  display: flex;\n  position: relative;\n}\n\n.containerRequest {\n  display: flex;\n  width: calc(100% - 55px);\n  padding: 30px 0px 0px 35px;\n  flex-direction: column;\n  margin-bottom: 30px;\n}\n\n.nullDescription {\n  color: #979ea4;\n}\n\n.centerText {\n  width: 100%;\n  text-align: left;\n  color: #979ea4;\n}\n\n.centerTextBlack {\n  color: #000;\n}\n\n.titleRequest {\n  font-size: 18px;\n}\n\n.containerBalls {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n\n.partNumberColluns {\n  display: flex;\n  padding-left: 20px;\n  font-size: 14px;\n}\n\n.genericGrid {\n  width: 100%;\n  display: flex;\n  padding: 0px 50px 20px 35px;\n}\n\n.containerGraphs {\n  width: 100%;\n  padding: 0px 50px 100px 35px;\n}\n\n.MuiDataGrid-root .MuiDataGrid-footerContainer {\n  border: none !important;\n  height: 0px !important;\n  background-color: #f9f9f9 !important;\n}\n\n.MuiDataGrid-root {\n  border: none !important;\n  height: 92% !important;\n}\n\n.MuiDataGrid-root .MuiDataGrid-filler {\n  background-color: #f9f9f9 !important;\n  border: none !important;\n  height: 0px !important;\n}\n\n.buttonImg img {\n  width: 22px;\n}\n\n.buttonActions {\n  margin-top: -15px;\n}\n\n.titleAprover {\n  font-size: 18px;\n  font-weight: 700;\n}\n\ndiv.titleAproverText {\n  font-size: 18px;\n  font-weight: 400;\n  font-family: \"Bosch Sans\", sans-serif !important;\n}\n\n.css-183rme2 {\n  display: none !important;\n}\n\n.ModalViewDescriptions {\n  height: 190px;\n}\n\n.containerCards {\n  display: flex;\n  justify-content: space-between;\n}\n\n.title_dash {\n  position: absolute;\n  border-bottom: 2px solid #ccc;\n  width: 100%;\n  top: 0;\n}\n\n.title_dash h2 {\n  color: #000;\n  font-weight: 700;\n  font-size: 20px;\n  margin: 10px;\n}\n\n.no_results {\n  font-weight: 400;\n  font-size: 20px;\n  color: #979ea4;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.wrap_text {\n  width: 180px;\n}\n\n.btn-delete{\n  cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
